export const Logo = ({ className = "h-12 w-12" }) => (
  <img
    src="/logo.png"
    alt="Rockin H Welding — Texas H logo"
    className={`${className} rounded-sm object-contain`}
  />
);
